module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-100 h-100 d-flex flex-column"
  }, [(_vm.canSeeInternalNote) ? _c('div', {
    staticClass: "d-flex flex-column flex-grow-1"
  }, [_c('label', [(_vm.hasInternalNote) ? _c('span', {
    staticClass: "reservation__notes--red-dot"
  }) : _vm._e(), _vm._v("\n            Internal notes:"), _c('span', {
    staticClass: "fs-smaller normal ml-1"
  }, [_vm._v("(internal use only)")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.internalNote),
      expression: "reservation.internalNote"
    }],
    staticClass: "flex-grow-1 p-1 fs-bigger bg-lighter darker bold",
    attrs: {
      "disabled": _vm.disabled || !_vm.canEditInternalNote,
      "rows": "1"
    },
    domProps: {
      "value": (_vm.reservation.internalNote)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "internalNote", $event.target.value)
      }, function () { return _vm.markFlagDirty('internalNote'); }]
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column flex-grow-1 mt-2"
  }, [_c('label', [(_vm.hasNotes) ? _c('span', {
    staticClass: "reservation__notes--red-dot"
  }) : _vm._e(), _vm._v("\n            Notes:"), _c('span', {
    staticClass: "fs-smaller normal ml-1"
  }, [_vm._v("(agents can see these)")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.note),
      expression: "reservation.note"
    }],
    staticClass: "flex-grow-1 p-1 fs-bigger bg-lighter darker bold",
    attrs: {
      "disabled": _vm.disabled,
      "rows": "1"
    },
    domProps: {
      "value": (_vm.reservation.note)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "note", $event.target.value)
      }, function () { return _vm.markFlagDirty('customer'); }]
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d92aa62"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/TabCustomer/Notes.vue
// module id = 1735
// module chunks = 0